import { useQuery } from '@tanstack/react-query';
import {
  featureFlagControllerAtMeQueryOptions,
  FeatureFlagControllerAtMeQueryParamsKeyEnumKey,
} from '../../generated/kubb';

export function useFeatureFlag(
  key: FeatureFlagControllerAtMeQueryParamsKeyEnumKey | undefined,
  productId?: string,
): boolean {
  const { data: { enabled = false } = {} } = useQuery({
    ...featureFlagControllerAtMeQueryOptions({ key: key!, productId }),
    enabled: key !== undefined,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return enabled;
}
